import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";

const SectionTable = ({ tasks, clickedItem }) => {
  const [selectionindex, setselectionindex] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const requestSort = (key) => {
    setSortConfig(prev =>
      prev.key === key ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
                       : { key, direction: "asc" }
    );
  };

  const sortIndicator = (key) =>
    sortConfig.key === key ? (sortConfig.direction === "asc" ? " ▲" : " ▼") : "";

  const getVal = (row, key) => {
    switch (key) {
      case "name": return String(row.name ?? "");
      case "quantity": return Number(row.quantity ?? 0);
      case "expectedDate": return Date.parse(row.expectedDate ?? "") || 0;
      case "status": return String(row.status ?? "");
      case "order.id": return String(row.order?.id ?? "");
      case "order.name": return String(row.order?.name ?? "");
      case "order.expected_delivery_date": return Date.parse(row.order?.expected_delivery_date ?? "") || 0;
      default: return "";
    }
  };

  const sorted = useMemo(() => {
    if (!Array.isArray(tasks)) return [];
    if (!sortConfig.key) return tasks;
    const dir = sortConfig.direction === "asc" ? 1 : -1;
    return [...tasks].sort((a, b) => {
      const va = getVal(a, sortConfig.key);
      const vb = getVal(b, sortConfig.key);
      if (va < vb) return -1 * dir;
      if (va > vb) return 1 * dir;
      return 0;
    });
  }, [tasks, sortConfig]);

  return (
    <div>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#f2f2f2" }}>
            <th style={tableHeaderStyle} onClick={() => requestSort("name")}>
              Προϊόν{sortIndicator("name")}
            </th>
            <th style={tableHeaderStyle} onClick={() => requestSort("quantity")}>
              Ποσότητα{sortIndicator("quantity")}
            </th>
            <th style={tableHeaderStyle} onClick={() => requestSort("expectedDate")}>
              Ημερομηνία Αναμονής{sortIndicator("expectedDate")}
            </th>
            <th style={tableHeaderStyle} onClick={() => requestSort("status")}>
              Κατάσταση{sortIndicator("status")}
            </th>
            <th style={tableHeaderStyle} onClick={() => requestSort("order.id")}>
              Αριθμός Παραγγελίας{sortIndicator("order.id")}
            </th>
            <th style={tableHeaderStyle} onClick={() => requestSort("order.name")}>
              Όνομα Πελάτη{sortIndicator("order.name")}
            </th>
            <th style={tableHeaderStyle} onClick={() => requestSort("order.expected_delivery_date")}>
              Ημερομηνία Αναμενόμενης Παράδοσης{sortIndicator("order.expected_delivery_date")}
            </th>
            <th style={tableHeaderStyle}>Selected</th>
          </tr>
        </thead>
        <tbody>
          {sorted && sorted.map((prds, i) => (
            <tr
              key={i}
              onClick={() => {
                setselectionindex(i);
                clickedItem(prds);
              }}
              style={{
                backgroundColor: selectionindex === i ? "#bdf29e" : "#fbfbfb",
                cursor: "pointer",
                color: selectionindex === i ? "black" : "blue",
                transition: "background-color 0.3s ease",
              }}
            >
              <td style={tableCellStyle}>{prds.name}</td>
              <td style={tableCellStyle}>{prds.quantity}</td>
              <td style={tableCellStyle}>{prds.expectedDate}</td>
              <td style={tableCellStyle}>{prds.status}</td>
              <td style={tableCellStyle}>{prds.order.id}</td>
              <td style={tableCellStyle}>{prds.order.name}</td>
              <td style={tableCellStyle}>{prds.order.expected_delivery_date}</td>
              <td style={tableCellStyle}>{selectionindex === i ? "✔" : ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Inline styles
const tableCellStyle = {
  padding: "10px",
  borderBottom: "1px solid #ddd",
};

const tableHeaderStyle = {
  padding: "10px",
  textAlign: "left",
  borderBottom: "2px solid #ddd",
  backgroundColor: "#f2f2f2",
  userSelect: "none",
  cursor: "pointer",
};

// PropTypes
SectionTable.propTypes = {
  tasks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      expectedDate: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      order: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired,
        expected_delivery_date: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  clickedItem: PropTypes.func.isRequired,
};

export default SectionTable;
